export const AUDIT_DEFAULT_ICON = 'folder-magnifying-glass';
